import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import {
  selectRoles,
  selectBoundTreeStatus,
} from 'src/v3/settings/settings.slice'
import {
  selectTourCompletion,
  selectTourCompletionsStatus,
  selectActiveTourID,
  tourStarted,
} from '../tours.slice'
import { getTourByID } from '../index'

// Scoped auto-start hook for a single named tour. Place on the page that "owns"
// the tour. Fires whenever the completion record is absent (never taken, or
// deleted by a retake action) — including after a page refresh mid-tour.
// Pass enabled=false to suppress the tour when the page is in a state where
// the target elements aren't rendered (e.g. create mode vs. edit mode).
export let usePageTour = (tourID: string, enabled = true) => {
  let dispatch = useAppDispatch()
  let roles = useAppSelector(selectRoles)
  let boundTreeStatus = useAppSelector(selectBoundTreeStatus)
  let completion = useAppSelector(selectTourCompletion(tourID))
  let completionsStatus = useAppSelector(selectTourCompletionsStatus)
  let activeTourID = useAppSelector(selectActiveTourID)

  let tour = getTourByID(tourID)

  useEffect(() => {
    if (!enabled) return
    if (completionsStatus !== 'fulfilled') return
    if (activeTourID) return
    if (!tour) return
    if (boundTreeStatus === 'limited' && !tour.allowInLimited) return
    if (
      tour.requiredRoles &&
      !roles.some((r) => tour.requiredRoles!.includes(r))
    )
      return
    if (completion && completion.completedVersion >= tour.version) return

    dispatch(tourStarted(tourID))
  }, [
    enabled,
    completionsStatus,
    completion,
    activeTourID,
    roles,
    boundTreeStatus,
    tourID,
    dispatch,
  ])
}
